/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export enum ContentBlockType {
  MAP = 'MAP',
  STREET_VIEW = 'STREET_VIEW',
  STATIC_TEXT = 'STATIC_TEXT',
  EDITABLE_TEXT = 'EDITABLE_TEXT',
  PREPARED_STATEMENT_IBIS = 'PREPARED_STATEMENT_IBIS',
  PREPARED_STATEMENT_GENERAL = 'PREPARED_STATEMENT_GENERAL',
  ERROR = 'ERROR',
  DISTRICT =  'DISTRICT',
  EDITABLE_TABLE = 'EDITABLE_TABLE',
  GOOGLE_SEARCH = 'GOOGLE_SEARCH'
}
